export default {
  directives: {
    onviewport: {
      inserted: function (el, binding, vnode) {

        const defaulSettings = { // default settings
          handlerIn: () => {}, // when element come in viewport,
          handlerOut: () => {}, // when element come out viewport
          viewportTriggerTop: 0, // move TOP viewport trigger lower (px)
          viewportTriggerBottom: 0, // move BOTTOM viewport trigger lower (px)
          elementTriggerTop: 0, // move TOP element trigger lower (px)
          elementTriggerBottom: 0 // // move Bottom element trigger lower (px)
        }

        const settings = {};
        if(typeof binding.value === 'object') {
          Object.assign(settings, defaulSettings, binding.value); // merge incoming settings with defaults
        } else{
          console.error('incorrect value'); // error, when incorrect input value
        }

        let inViewportOuter = false; // old inViewport status (before scroll)
        document.addEventListener('scroll', () => {

          let topTrigger = (el.getBoundingClientRect().top + settings.elementTriggerTop) - (window.innerHeight + settings.viewportTriggerBottom) <= 0; // is top of element higher than bottom of viewport
          let bottomTrigger = (el.getBoundingClientRect().bottom + settings.elementTriggerBottom) - settings.viewportTriggerTop <= 0; // is bottom of element higher than top of viewport
          let inViewportInner = topTrigger && !bottomTrigger; // inViewport status (after scroll)

          if(inViewportOuter !== inViewportInner) { // detect changing inViewport status, to prevent handling on each scroll event
            if(inViewportInner) {
              settings.handlerIn();
            } else {
              settings.handlerOut();
            }
          }
          inViewportOuter = inViewportInner; // change inViewport status

        });

      }
    }
  }
}
